"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaderboardTable = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var react_1 = require("react");
var helpers_1 = require("../../utilities/helpers");
var LeaderboardBody_1 = require("./LeaderboardBody");
var LeaderboardHeader_1 = require("./LeaderboardHeader");
var LeaderboardSubHeader_1 = require("./LeaderboardSubHeader");
var LeaderboardTable = function (_a) {
    var data = _a.data, columns = _a.columns, renderHeader = _a.renderHeader, renderRow = _a.renderRow, renderBodyHeader = _a.renderBodyHeader, renderBodyHeaderRow = _a.renderBodyHeaderRow, _b = _a.containerClassNames, containerClassNames = _b === void 0 ? "" : _b, _c = _a.headerClassNames, headerClassNames = _c === void 0 ? "" : _c, headerColumns = _a.headerColumns, renderSubHeaderButton = _a.renderSubHeaderButton, renderFooter = _a.renderFooter, isRaceActive = _a.isRaceActive, currency = _a.currency;
    var isInScheduleState = (0, react_1.useMemo)(function () {
        var now = Date.now();
        var startTime = new Date(data.start).getTime();
        return now - startTime < 0;
    }, [data]);
    var active = (0, react_1.useMemo)(function () {
        if (typeof isRaceActive !== "boolean") {
            var currentDate = new Date().getTime();
            var startDate = new Date(data.start).getTime();
            var endDate = new Date(data.end).getTime();
            return currentDate < endDate && currentDate > startDate;
        }
        return isRaceActive;
    }, [isRaceActive, data]);
    var playerPosition = (0, react_1.useMemo)(function () {
        if (!data.players) {
            return "-";
        }
        var playerIndex = data.players.findIndex(function (player) { return player.isYou; });
        if (playerIndex > -1) {
            return playerIndex + 1;
        }
        return "-";
    }, [data]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, clsx_1.default)((0, helpers_1.handleClassNames)("leaderboard-container", containerClassNames), active && "leaderboard-container--active") }, { children: [renderHeader ? renderHeader(headerColumns) :
                (0, jsx_runtime_1.jsx)(LeaderboardHeader_1.LeaderboardHeader, { games: data.games || [], isSchedule: isInScheduleState, currency: currency, data: data, columns: headerColumns, containerClassName: headerClassNames }), (0, jsx_runtime_1.jsx)(LeaderboardSubHeader_1.LeaderboardSubHeader, { code: data.code, totalPlayers: data.totalPlayers, playerPosition: playerPosition, renderButton: renderSubHeaderButton }), !isInScheduleState && (0, jsx_runtime_1.jsx)(LeaderboardBody_1.LeaderboardBody, { currency: currency, isRaceActive: active, renderFooter: renderFooter, renderHeaderRow: renderBodyHeaderRow, renderHeader: renderBodyHeader, renderRow: renderRow, data: data, columns: columns })] })));
};
exports.LeaderboardTable = LeaderboardTable;
